import axios from 'axios';
import { message } from 'antd';

//let rootUrl = process.env.REACT_APP_BASE_URL;
let rootUrl = '/api/';
let showMsg = false;
if(process.env.NODE_ENV === 'production') {
    rootUrl = resolveBackendUrl() + '/'
}

// [MULTI_DOMAIN] 获取本项目真实域名。
// 表单嵌入别的网站时 window.location.origin 是宿主域名，
// 真实域名由 embed loader（embedCustomForm.js）在加载 bundle 前注入 window.__PROJECT_ORIGIN__。
function resolveProjectOrigin() {
    if (typeof window !== 'undefined' && window.__PROJECT_ORIGIN__) {
        return window.__PROJECT_ORIGIN__;
    }
    return window.location.origin;
}

// [MULTI_DOMAIN] 按项目域名选择后端：
// gaxas 域名（REACT_APP_GAXAS_PAGE_URL）→ REACT_APP_GAXAS_BACKEND_URL，
// 其余（含 e-com365 域名）→ REACT_APP_BACKEND_URL
function resolveBackendUrl() {
    const normalize = (url) => (url || '').replace(/\/+$/, '').toLowerCase();
    const projectOrigin = normalize(resolveProjectOrigin());
    const gaxasPageUrl = normalize(process.env.REACT_APP_GAXAS_PAGE_URL);
    if (gaxasPageUrl && projectOrigin === gaxasPageUrl) {
        return process.env.REACT_APP_GAXAS_BACKEND_URL;
    }
    return process.env.REACT_APP_BACKEND_URL;
}

axios.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = "application/json";
        if (config.method === 'get') {
            //  给data赋值以绕过if判断
            config.data = true
        }
        else if (config.method === 'delete') {
            config.data = {
                data: true
            }
        }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

axios.interceptors.response.use(response => {
    if (response.data.code === 401) {
        if (!showMsg) {
            showMsg = true;
            message.error(response.data.msg);
            setTimeout(() => {
                showMsg = false;
            }, 3000);
        }
    }
    return response;
}, (error) => {
    if (!showMsg) {
        showMsg = true;
        setTimeout(() => {
            showMsg = false;
        }, 3000);
    }
    return Promise.reject(error);
}
)

//请求封装
export function get(url, param, merchant_code, service_code) {
    //setHeaders(url);
    return new Promise((resolve, reject) => {
        let configUrl = rootUrl + url;
        if(merchant_code && service_code) {
            configUrl = process.env.REACT_APP_APIGATEWAY_URL + `/${merchant_code}/${service_code}/public/` + url;
        }
        axios.get(configUrl, { params: param }).then(response => {
            resolve(response.data)
        }, err => {
            reject(err)
        }).catch((error) => {
            reject(error)
        })
    })
}

export function post(url, params, merchant_code, service_code) {
    //setHeaders(url);
    let configUrl = rootUrl + url;
    if(merchant_code && service_code) {
        configUrl = process.env.REACT_APP_APIGATEWAY_URL + `/${merchant_code}/${service_code}/public/` + url;
    }
    return new Promise((resolve, reject) => {
        axios.post(configUrl, params).then(response => {
            resolve(response.data);
        }, err => {
            reject(err);
        }).catch((error) => {
            reject(error)
        })
    })
}

export function put(url, params, merchant_code, service_code) {
    //setHeaders(url);
    let configUrl = rootUrl + url;
    if(merchant_code && service_code) {
        configUrl = process.env.REACT_APP_APIGATEWAY_URL + `/${merchant_code}/${service_code}/public/` + url;
    }
    return new Promise((resolve, reject) => {
        axios.put(configUrl, params).then(response => {
            resolve(response.data);
        }, err => {
            reject(err);
        }).catch((error) => {
            reject(error)
        })
    })
}

export function deleted(url, merchant_code, service_code) {
    //setHeaders(url);
    let configUrl = rootUrl + url;
    if(merchant_code && service_code) {
        configUrl = process.env.REACT_APP_APIGATEWAY_URL + `/${merchant_code}/${service_code}/public/` + url;
    }
    return new Promise((resolve, reject) => {
        axios.delete(configUrl).then(response => {
            resolve(response.data);
        }, err => {
            reject(err);
        }).catch((error) => {
            reject(error)
        })
    })
}